export default __webpack_public_path__ + "static/media/ic_tracking_marker.02ded715.svg";